import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Common Auth Headers
const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");

    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
    };
};

// ================= GET ADMIN BILLING DATA =================
export const getAdminBillingDataAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/admin-billing/admin/1`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching billing data:", error);
        throw error;
    }
};

export const saveAdminBillingDataAPI = async (payload) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/food/api/admin-billing/add`,
            payload,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error saving billing data:", error);
        throw error;
    }
};



// ================= GET CATERING BILLING DATA =================
export const getCateringBillingDataAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/catering/api/admin/billing/get`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching catering billing data:", error);
        throw error;
    }
};

// ================= SAVE / UPDATE CATERING BILLING =================
export const saveOrUpdateCateringBillingAPI = async (
    billingData,
    billingFields
) => {
    try {
        // Build payload dynamically
        const payload = {
            id: billingData.id || 0,
            couponAmount: Number(billingData.couponAmount) || 0,
            distance: Number(billingData.distance) || 0,
        };

        billingFields.forEach(({ key }) => {
            payload[key] = Number(billingData[key]) || 0;

            let backendKey;

            // Backend typo fix
            if (key === "commission") {
                backendKey = "commisionApplicable";
            } else if (key === "deliveryFeeperThousandperKm") {
                backendKey = "deliveryFeeperkmApplicable";
            } else {
                backendKey = `${key}Applicable`;
            }

            payload[backendKey] = Boolean(
                billingData[`${key}Applicable`]
            );
        });

        const isUpdate =
            billingData.id && billingData.id !== 0;

        const response = await axios({
            method: isUpdate ? "put" : "post",
            url: isUpdate
                ? `${BASE_URL}/catering/api/admin/billing/update`
                : `${BASE_URL}/catering/api/admin/billing/create`,
            headers: getAuthHeaders(),
            data: payload,
        });

        return response.data;
    } catch (error) {
        console.error(
            "Error saving/updating catering billing:",
            error
        );

        throw error;
    }
};


export const getPromotionBillingAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/promotions/api/user/get/billing`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error fetching promotion billing data:",
            error
        );

        throw error;
    }
};

export const saveOrUpdatePromotionBillingAPI = async (
    data,
    key
) => {
    try {
        const payload = {
            ...data,
            [key]: Number(data[key]),
        };

        const response = data.id
            ? await axios.put(
                `${BASE_URL}/promotions/api/admin/update/billing`,
                payload,
                {
                    headers: getAuthHeaders(),
                }
            )
            : await axios.post(
                `${BASE_URL}/promotions/api/admin/create/billing`,
                payload,
                {
                    headers: getAuthHeaders(),
                }
            );

        return response.data;
    } catch (error) {
        console.error(
            "Error saving/updating promotion billing:",
            error
        );

        throw error;
    }
};
// ================= GET DELIVERY BILLING =================
export const getDeliveryBillingAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/delivery/api/admin/get/billing`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error fetching delivery billing data:",
            error
        );

        throw error;
    }
};

// ================= SAVE / UPDATE DELIVERY BILLING =================
export const saveOrUpdateDeliveryBillingAPI = async (
    data,
    key
) => {
    try {
        const payload = {
            ...data,
            [key]: Number(data[key]),
        };

        const response = data.id
            ? await axios.put(
                `${BASE_URL}/delivery/api/admin/billing`,
                payload,
                {
                    headers: getAuthHeaders(),
                }
            )
            : await axios.post(
                `${BASE_URL}/delivery/api/admin/billing`,
                payload,
                {
                    headers: getAuthHeaders(),
                }
            );

        return response.data;
    } catch (error) {
        console.error(
            "Error saving/updating delivery billing:",
            error
        );

        throw error;
    }
};